import moment from "moment";
import "moment/locale/es";
import {cuentaMask, dineroDisabledMask} from '../Components/Items'
import { HeaderEmpresaCard } from "../Components/PdfComponents/HeaderEmpresaCard";

moment.locale("es");

const reporteDeComprasPdf = (values) => {
    const empresa = values.empresa
    const logoBiwo = values.logoBiwo;
    let filtrados = []
    if(values.proveedores !== 0 && values.proveedores && values.proveedores.length > 0){
        let textoFiltrado = ''
        values.proveedores.map((valueProveedor) => {
            textoFiltrado += `${(valueProveedor.persona ? valueProveedor.nombre : (valueProveedor.nombre+' '+valueProveedor.apellidoPaterno+' '+valueProveedor.apellidoMaterno)) + valueProveedor.razonSocial + " - " + valueProveedor.rfc}\n`
            return null
        })
        filtrados.push([
            {text: 'Proveedores:', style: 'subheader'},
            
            {text: textoFiltrado, style: 'textoChico'}
          ])
    }

    if(values.filtrarProyecto === 1){
        let textoFiltrado = ''
        values.proyectos.map((valueProyectos) => {
            textoFiltrado += `${valueProyectos.nombre}\n`
            return null
        })
        filtrados.push([
            {text: 'Proyectos:', style: 'subheader'},
            
            {text: textoFiltrado, style: 'textoChico'}
          ])
    }

    if(values.filtrarProyecto === 2){
        filtrados.push([
            {text: 'Unidad de Negocio:', style: 'subheader'},
            
            {text: `${cuentaMask(
                values.unidadDeNegocio.nivel1 + values.unidadDeNegocio.nivel2 + values.unidadDeNegocio.nivel3 + values.unidadDeNegocio.nivel4 +values.unidadDeNegocio.nivel5
              ) +
                " - " +
                values.unidadDeNegocio.nombre}`, style: 'textoChico'}
          ])
    }

    let compras = []

    // Variables para calcular totales
    let totalCompras = 0;
    let totalSubtotal = 0;
    let totalImpuestos = 0;

    const esValorVacio = (v) =>
        v === undefined ||
        v === null ||
        v === '' ||
        (typeof v === 'number' && isNaN(v));
    const dineroOVacio = (v) => (esValorVacio(v) ? '' : dineroDisabledMask(v));
    const folioConSerie = (folio, serie) => {
        if (esValorVacio(folio)) return '';
        return esValorVacio(serie) ? `${folio}` : `${folio} - ${serie}`;
    };

    for(const valueCompra of values.compras){
        const properties = valueCompra.colorStyle ? {background: valueCompra.colorStyle} : {}

        // Acumular totales
        totalCompras += parseFloat(valueCompra.total) || 0;
        totalSubtotal += parseFloat(valueCompra.subtotal) || 0;
        totalImpuestos += parseFloat(valueCompra.impuestos) || 0;

        compras.push([
            {text: folioConSerie(valueCompra.folio, valueCompra.serie), style: 'textoTabla', alignment: 'left'},
            {text: isNaN(valueCompra.fechaFactura) ? moment(valueCompra.fechaFactura, "DD/MM/YYYY").locale('es').format('L') : valueCompra.fechaFactura, style: 'textoTabla', alignment: 'center'},
            {text: valueCompra.proveedor, style: 'textoTabla', alignment: 'left'},
            {text: dineroOVacio(valueCompra.subtotal), style: 'textoTabla', alignment: 'right'},
            {text: dineroOVacio(valueCompra.impuestos), style: 'textoTabla', alignment: 'right'},
            {text: dineroOVacio(valueCompra.total), style: 'textoTabla', alignment: 'right'},
            {
                text: (() => {
                  switch (valueCompra.estado) {
                    case 1:
                      return "Sin recepciones";
                    case 2:
                      return "Con recepciones parciales";
                    case 3:
                      return "Con recepciones completas";
                    default:
                      return "Desconocido";
                  }
                })(),
                ...properties,
                style: 'textoTabla',
                alignment: 'left'
              },
              
        ])
    }

    // Agregar fila de totales en la misma tabla
    compras.push([
        { text: 'TOTAL:', style: 'tituloTabla', alignment: 'left', border: [true, true, true, true], fillColor: '#cccccc' },
        { text: '', style: 'textoTabla', border: [false, true, false, true], fillColor: '#cccccc' },
        { text: '', style: 'textoTabla', border: [false, true, false, true], fillColor: '#cccccc' },
        { text: dineroDisabledMask(totalSubtotal), style: 'textoTotal', alignment: 'right', border: [true, true, true, true], fillColor: '#cccccc' },
        { text: dineroDisabledMask(totalImpuestos), style: 'textoTotal', alignment: 'right', border: [true, true, true, true], fillColor: '#cccccc' },
        { text: dineroDisabledMask(totalCompras), style: 'textoTotal', alignment: 'right', border: [true, true, true, true], fillColor: '#cccccc' },
        { text: '', style: 'textoTabla', border: [false, true, true, true], fillColor: '#cccccc' },
    ]);

    if(filtrados.length === 0){
        filtrados.push([
            {text: 'No tiene filtrados adicionales', style: 'subheader'},

            {text: '', style: 'textoChico'}
      ] )
    }

    var dd = {
        footer: {
            image: 'logoBiwo', alignment: 'center', width: 80
        },
          content: [
              {
                  style: 'tableExample',
                  table: {
                      widths: [ '18%', '52%', '30%'],
                      layout: {
                          defaultBorder: false,
                      },
                      body: [
                          [
                              ...HeaderEmpresaCard(empresa, false,false,
                              {
                                  border: [false, false, false, false],
                                      table: {
                                      headerRows: 1,
                                      widths: ['100%'],
                                  
                                      body: [
                                          [{text: 'Fecha Inicial:', style: 'subheader', alignment: 'center'}],
                                          [{text: moment(values.fechaInicial).locale('es').format('LL'), style: 'textoChico', alignment: 'center'}],
                                          [{text: 'Fecha Final:', style: 'subheader', alignment: 'center'}],
                                          [{text: moment(values.fechaFinal).locale('es').format('LL'), style: 'textoChico', alignment: 'center'}],
                                          [{text: 'Fecha de Impresión:', style: 'subheader', alignment: 'center'}],
                                          [{text: moment().locale('es').format('LL'), style: 'textoChico', alignment: 'center'}],
                                      ]
                                  },
                                  layout: 'noBorders'
                              }),
                          ]
      
                      ]
                  },
              },
              {
                text:
                "Reporte de Ordenes de Compra",
                style: "tableHeaderIzquierda",
                },
              {text: 'Datos de filtrado:'},
              {
                  style: 'tableExample',
                  table: {
                      widths: ['20%', '80%'],
                      layout: {
                                          defaultBorder: false,
                                      },
                      
                      body: filtrados,
                  },
                              layout: {
                      hLineWidth: function (i, node) {
                          return (i === 0 || i === node.table.body.length) ? 1 : 1;
                      },
                      vLineWidth: function (i, node) {
                          return (i === 0 || i === node.table.widths.length) ? 1 : 1;
                      },
                      hLineColor: function (i, node) {
                          return '#adaaaa';
                      },
                      vLineColor: function (i, node) {
                          return '#adaaaa';
                      },
                      hLineStyle: function (i, node) {
                          if (i === 0 || i === node.table.body.length) {
                              return null;
                          }
                          return {dash: {length: 2, space: 1}};
                      },
                      vLineStyle: function (i, node) {
                          if (i === 0 || i === node.table.widths.length) {
                              return null;
                          }
                          return {dash: {length: 2}};
                      },
                      // paddingLeft: function(i, node) { return 4; },
                      // paddingRight: function(i, node) { return 4; },
                      // paddingTop: function(i, node) { return 2; },
                      // paddingBottom: function(i, node) { return 2; },
                      // fillColor: function (i, node) { return null; }
                  }
                  
              },
              
              {
                  style: 'tableExample',
                  table: {
                      widths: ['12%', '12%', '28%', '10%', '10%', '10%', '18%'],
                      layout: {
                          defaultBorder: true,
                      },
                      body: [
                          [
                            {text: 'Folio', style: 'tituloTabla'},		              
                            {text: 'Fecha', style: 'tituloTabla'},
                            {text: 'Proveedor', style: 'tituloTabla'},
                            {text: 'Subtotal', style: 'tituloTabla'},
                            {text: 'Saldo', style: 'tituloTabla'},
                            {text: 'Total', style: 'tituloTabla'},
                            {text: 'Estado', style: 'tituloTabla'},
                          ],
                          //Falta esto en el backend y ya
                          ...compras
                      ]
                  },
                  layout: {
                      fillColor: (rowIndex, node, columnIndex) => {
                          // La última fila (totales) siempre en gris, las demás alternan
                          if (rowIndex === node.table.body.length - 1) {
                              return "#cccccc";
                          }
                          return rowIndex % 2 === 0 ? "#e8e8e8" : "#ffffff";
                      },
                      hLineWidth: function (i, node) {
                          return (i === 0 || i === node.table.body.length) ? 1 : 1;
                      },
                      vLineWidth: function (i, node) {
                          return (i === 0 || i === node.table.widths.length) ? 1 : 1;
                      },
                      hLineColor: function (i, node) {
                          return '#adaaaa';
                      },
                      vLineColor: function (i, node) {
                          return '#adaaaa';
                      },
                      hLineStyle: function (i, node) {
                          if (i === 0 || i === node.table.body.length) {
                              return null;
                          }
                          return {dash: {length: 2, space: 1}};
                      },
                      vLineStyle: function (i, node) {
                          if (i === 0 || i === node.table.widths.length) {
                              return null;
                          }
                          return {dash: {length: 2}};
                      },
                      // paddingLeft: function(i, node) { return 4; },
                      // paddingRight: function(i, node) { return 4; },
                      // paddingTop: function(i, node) { return 2; },
                      // paddingBottom: function(i, node) { return 2; },
                      // fillColor: function (i, node) { return null; }
                  }
              },
              

              
          ],
          images: {
            logo: empresa.logo.base64Completa,
            logoBiwo: logoBiwo.base64Completa,
          },
          styles: {
            tableHeaderIzquierda: { bold: true, fontSize: 18, color: "black" },
              header: {
                  fontSize: 9,
                  bold: true,
              },
              subheader: {
                  fontSize: 8,
                  bold: true,
              },
              tableExample: {
                  margin: [0, 5, 0, 5]
              },
              tablaSinMargen: {
                  margin: [0, 0, 0, 0]
              },
              tableHeader: {
                  bold: true,
                  fontSize: 12,
                  color: 'black',
                  alignment: 'center'
              },
              textoChico:{
                  fontSize: 8
              },
              tituloTabla:{
                  fontSize: 8,
                  bold: true, 
                  fillColor: '#cccccc', 
                  style: 'subheader', 
                  alignment: 'center',
                  border: true
              },
              textoTabla: {
                  fontSize: 8,
                  italics: false
              },
              textoTotal: {
                fontSize: 7,
                italics: false
            }
          },
          pageSize: 'LETTER',
          pageMargins: [ 20, 20, 20, 60 ],
    }
  return dd;
};


export default reporteDeComprasPdf;